"use client";

import React from "react";

interface AbisLogoIconProps {
  className?: string;
  size?: "sm" | "md" | "lg";
}

const AbisLogoIcon: React.FC<AbisLogoIconProps> = ({
  className = "",
  size = "md",
}) => {
  const sizeClasses = {
    sm: "w-4 h-4",
    md: "w-5 h-5",
    lg: "w-6 h-6",
  };

  return (
    <svg
      viewBox="0 0 370.66666 416"
      className={`${sizeClasses[size]} ${className}`}
      shapeRendering="geometricPrecision"
      role="img"
      aria-label="ABIS Logo"
    >
      <g transform="matrix(1.3333333,0,0,-1.3333333,0,416)">
        <g transform="scale(0.1)">
          <path
            d="m 1359.26,2777.5 c 105.39,128.48 265.31,247.81 420.9,311.64 99.57,42.31 213.47,39.18 313.98,1.8 153.4,-55.35 288.63,-178.13 406.45,-289.14 -104.73,-136.41 -234.81,-237.5 -394.69,-306.29 -105.47,-46.6 -228.24,-47.19 -334.92,-4.18 -149.38,58.36 -308.6,165.47 -411.72,286.17 z"
            style={{
              fill: "currentColor",
              fillOpacity: 1,
              fillRule: "nonzero",
              stroke: "none",
            }}
          />
          <path
            d="M 2770.66,1367.58 C 2770.66,596.449 2120.43,1.60156 1351.95,1.60156 583.52,1.60156 1.76172,620 1.76172,1391.37 c 0,288.75 164.64828,1067.69 972.80828,1311.33 0,0 384.69,-587.58 963.01,-587.5 285.04,0.03 501.95,163.04 501.95,163.04 h 0.67 c 0,0 330.46,-322.81 330.46,-910.66 z"
            style={{
              fill: "currentColor",
              fillOpacity: 1,
              fillRule: "nonzero",
              stroke: "none",
            }}
          />
        </g>
      </g>
    </svg>
  );
};

export default AbisLogoIcon;
